import { useState } from 'react';

/**
 * Custom hook to manage FAQ open/close state
 * Allows multiple FAQ items to be open simultaneously
 */
export const useFaqState = () => {
  const [openIndexes, setOpenIndexes] = useState<Set<number>>(new Set());

  const toggleFaq = (index: number) => {
    setOpenIndexes((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return { openIndexes, toggleFaq };
};
